// extracted by mini-css-extract-plugin
module.exports = {"status":"status-26uot","waiting":"waiting-zujxD","rejected":"rejected-1D7m6","processing":"processing-uGgds","icon":"icon-2PFf2"};